<template>
  <div class="screen-wrapper">
    <!-- 大屏顶部 -->
    <div class="screen-top">
      <picture-view ref="picView" videoId="video1" heightStyle="height: 455px"></picture-view>
      <sale-chart-person
        class="chart-container"
        @projectChange="projectChange"
        @handleFull="handleFull"
        :isFull="isFull"
      ></sale-chart-person>
      <!-- <center-chart-person>
        <screen-title :is-full="isFull" @full="handleFull"></screen-title>
      </center-chart-person> -->
      <device-data-chart ref="devDataChart"></device-data-chart>
    </div>
    <!-- 大屏底部 -->
    <div class="screent-bottom">
      <quality-chart-person ref="quaChart"></quality-chart-person>
      <device-chart-person ref="devChart"></device-chart-person>
      <keyword-chart-person ref="keyChart"></keyword-chart-person>
    </div>
    <div class="full-screen-wrapper" v-if="isFull">
      <div class="screen-top">
        <picture-view ref="picViewF" videoId="video2" heightStyle="height: 100%"></picture-view>
        <sale-chart-person
          class="chart-container"
          @projectChange="projectChangeF"
          @handleFull="close"
          :isFull="isFull"
        ></sale-chart-person>
        <!-- <center-chart-person>
          <screen-title :is-full="isFull" @full="close"></screen-title>
        </center-chart-person> -->
        <device-data-chart ref="devDataChartF"></device-data-chart>
      </div>
      <div class="screent-bottom" style="">
        <quality-chart-person ref="quaChartF"></quality-chart-person>
        <device-chart-person ref="devChartF"></device-chart-person>
        <keyword-chart-person ref="keyChartF"></keyword-chart-person>
      </div>
    </div>
  </div>
</template>

<script>
import SaleChartPerson from './components/SaleChartPerson'
import CenterChartPerson from './components/CenterChartPerson'
import DeviceChartPerson from './components/DeviceChartPerson'
import PictureView from './components/PictureView'
import QualityChartPerson from './components/QualityChartPerson.vue'
import DeviceDataChart from './components/DeviceDataChart'
import KeywordChartPerson from './components/KeywordChartPerson'
import ScreenTitle from './components/ScreenTitle/index'
export default {
  name: 'BigScreenPerson',
  components: {
    SaleChartPerson,
    CenterChartPerson,
    DeviceChartPerson,
    PictureView,
    QualityChartPerson,
    DeviceDataChart,
    KeywordChartPerson,
    ScreenTitle,
  },
  data() {
    return {
      isFull: false,
      // 当前项目id
      projectId: null,
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize, true)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize, true)
  },
  methods: {
    resize() {
      if (!this.isFullscreen()) {
        this.isFull = false
      }
    },
    isFullscreen() {
      return (
        document.fullscreenElement ||
        document.msFullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        false
      )
    },
    launchFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
    },
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    },
    handleFull(visiable) {
      this.launchFullscreen(document.documentElement)
      this.isFull = visiable
    },
    close() {
      this.exitFullscreen(document.documentElement)
      this.isFull = false
    },
    // 项目改变
    projectChange(projectId) {
      this.projectId = projectId
      this.allViewReflush()
    },
    // 项目改变(全屏)
    projectChangeF(projectId) {
      this.projectId = projectId
      this.allViewReflushF()
    },
    // 所有视图更新
    allViewReflush() {
      this.$refs.picView.reloadData(this.projectId)
      this.$refs.devDataChart.reloadData(this.projectId)
      this.$refs.quaChart.reloadData(this.projectId)
      this.$refs.devChart.reloadData(this.projectId)
      this.$refs.keyChart.reloadData(this.projectId)
    },
    // 所有视图更新(全屏)
    allViewReflushF() {
      this.$refs.picViewF.reloadData(this.projectId)
      this.$refs.devDataChartF.reloadData(this.projectId)
      this.$refs.quaChartF.reloadData(this.projectId)
      this.$refs.devChartF.reloadData(this.projectId)
      this.$refs.keyChartF.reloadData(this.projectId)
    },
  },
}
</script>

<style lang='less' scoped>
.screen-wrapper {
  overflow-x: scroll;
  position: relative;
  .screen-top,
  .screent-bottom {
    display: flex;
    height: 50%;
  }
}
.full-screen-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #353c84;
  z-index: 999;
  width: 100%;
  height: 100%;
  overflow-x: scroll;
}
</style>
